export default "__VITE_ASSET__CTVj_PAF__"